// extracted by mini-css-extract-plugin
module.exports = {"formWrap":"index_formWrap-1assM","left":"index_left-1MHSt","item":"index_item-KlKMi","right":"index_right-3nL1M","title":"index_title-3VqOn","btnWrap":"index_btnWrap-KGXnP"};